import {
  Measure
} from '../../../common/measure';

import {
  Filter
} from '../../../common/filter';

require('./threshold.component.scss');
class ThresholdController {
  constructor(
    $scope,
    $element,
    $timeout,
    rx,
    observeOnScope,
  ) {
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.Measure = Measure;
    this.period = {};
    this.MAX_SAFE_INTEGER = 9007199254740991;

    if (!this.filter.threshold_period) this.filter.threshold_period = 60;
    if (!this.filter.threshold_type) this.filter.threshold_type = this.filter.measure;
    this.threshold = {
      record_count: 100,
      call_duration_sum: 60,
      activity_time_sum: 600000000,
      file_size_sum: 1000000,
    };
    this.threshold[this.filter.threshold_type] = this.filter.threshold;

    this.setPeriod();
    this.setTime();
    this.subscriptions = [
      rx.Observable.merge(
        // observeOnScope($scope, '$ctrl.threshold'),
        observeOnScope($scope, '$ctrl.filter.send_threshold')
        .distinctUntilChanged(null, (t1, t2) => {
          this.filter.threshold_type = this.filter.measure;
          this.initThreshold();
        }),
        observeOnScope($scope, '$ctrl.filter.threshold_type')
        .distinctUntilChanged(null, (t1, t2) => {
          this.initThreshold();
        }),
        observeOnScope($scope, '$ctrl.filter.threshold_period'),
        observeOnScope($scope, '$ctrl.filter.threshold')
        .distinctUntilChanged(null, (t1, t2) => {
          this.threshold[this.filter.threshold_type] = this.filter.threshold;
          this.setThreshold();
          return t2.oldValue && t2.newValue;
        }),
      ).subscribe(() => {
        // this.setThresholdPeriod();
        this.updateFilterTime();
      })
    ];
  }

  $onDestroy() {
    this.subscriptions.forEach((s) => {
      if (s.dispose) s.dispose();
    });
  }

  initThreshold() {
    if (!(this.filter.threshold_type in this.threshold)) {
      this.filter.threshold = 1;
      this.threshold[this.filter.threshold_type] = this.filter.threshold;
    } else {
      this.setThreshold();
    }
    this.filter.threshold_period = 60;
    this.period = {};
    this.setPeriod();
    this.setTime();


  }

  setThreshold() {
    if (!this.threshold[this.filter.threshold_type]) this.threshold[this.filter.threshold_type] = 1;
    else this.threshold[this.filter.threshold_type] = this.validNum(this.threshold[this.filter.threshold_type]);
    this.filter.threshold = this.threshold[this.filter.threshold_type];
    this.filter.measure = this.filter.threshold_type;
  }

  updateFilterTime() {
    if (this.filter.send_threshold && this.filter.threshold_period && this.filter.threshold) {
      const now = new Date();
      this.filter.timeTo = Filter.dateToUrl(now);
      const dateFrom = new Date(now.getTime() - this.filter.threshold_period * 1000 * 60);
      this.filter.timeFrom = Filter.dateToUrl(dateFrom);
    }
  }

  setTime() {
    let seconds = this.filter.threshold_type === 'activity_time_sum' ?
      Math.ceil(this.threshold[this.filter.threshold_type] / 10000000) : this.threshold[this.filter.threshold_type];
    this.hours = Math.floor(seconds / 3600);
    seconds %= 3600;
    this.mins = Math.floor(seconds / 60);
    this.sec = seconds % 60;
  }

  setPeriod() {
    let mins = this.filter.threshold_period;
    this.period.days = Math.floor(mins / 1440);
    mins -= this.period.days * 1440;
    this.period.hours = Math.floor(mins / 60);
    this.period.mins = mins - this.period.hours * 60;
  }

  validNum(num) {
    if (!num || num < 0) return 0;
    return num;
  }

  setThresholdPeriod() {
    this.filter.threshold_period = this.validNum(this.period.days) * 1440 +
      this.validNum(this.period.hours) * 60 + this.validNum(this.period.mins);
    if (this.filter.threshold_period > this.MAX_SAFE_INTEGER)
      this.filter.threshold_period = this.MAX_SAFE_INTEGER;
  }


  get filter() {
    return this.$scope.filter;
  }


  timeChange() {
    const seconds = (this.sec || 0) + (this.mins || 0) * 60 + (this.hours || 0) * 3600;
    this.timeRes = seconds;

    if (this.filter.threshold_type === 'activity_time_sum') this.threshold[this.filter.threshold_type] = seconds * 10000000;
    else if (this.filter.threshold_type === 'call_duration_sum') this.threshold[this.filter.threshold_type] = seconds;

    if (this.threshold[this.filter.threshold_type] > this.MAX_SAFE_INTEGER)
      this.threshold[this.filter.threshold_type] = this.MAX_SAFE_INTEGER;
    this.setThreshold();
  }

  get isTime() {
    return this.filter.threshold_type === 'activity_time_sum' || this.filter.threshold_type === 'call_duration_sum';
  }
}

export function ThresholdComponent() {
  return {
    restrict: 'E',
    template: require('./threshold.component.html'),
    scope: false,
    controller: ThresholdController,
    controllerAs: '$ctrl',
  };
}



// WEBPACK FOOTER //
// ./src/filter/editor/threshold/threshold.component.js